// extracted by mini-css-extract-plugin
export default {"reveal":"Reveal_reveal__uUUqY","visible":"Reveal_visible__XRJK1"};